import { render } from "./AppSideBar.vue?vue&type=template&id=95d04294"
import script from "./AppSideBar.vue?vue&type=script&lang=js"
export * from "./AppSideBar.vue?vue&type=script&lang=js"

import "./AppSideBar.vue?vue&type=style&index=0&id=95d04294&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__